import { css } from '@emotion/react';

import { MediaBP as MQ } from '../../styles/mediaQuery';
import { colors } from '../colors';
import { ZeeFontBold } from '../font';

export const heading = css`
  title: 'heading';
  ${ZeeFontBold(14, 21)}
  margin: auto;
  color: #f2f2f2;
  ${MQ.MediaLg} {
    ${ZeeFontBold(28, 42)}
    margin-bottom: 18px;
    margin-top: 0;
  }
`;

export const backgroundWrapper = css`
  title: 'backgroundWrapper';
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  display: flex;
  overflow: hidden;
  &::before {
    background: linear-gradient(
      180deg,
      rgba(15, 6, 23, 0.54) 0,
      rgba(15, 6, 23, 0.99)
    );
    background-position: top;
    background-repeat: no-repeat;
    background-size: cover;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    will-change: transform;
    z-index: 1;
  }
`;
export const backgroundGrid = css`
  title: 'backgroundGrid';
  border-radius: 0;
  margin: 0;
  float: left;
  flex: 0 0 20%;
  ${MQ.MediaLg} {
    flex: 0 0 12.5%;
  }
  ${MQ.MediaXl} {
    flex: 0 0 8.33%;
  }
`;

export const backgroundGridImage = css`
  width: 20vw;
  height: 30vw;
  ${MQ.MediaLg} {
    width: 12.5vw;
    height: 18.75vw;
  }
  ${MQ.MediaXl} {
    width: 8.33vw;
    height: 12.5vw;
  }
`;

export const containerMinHeight = css`
  background: ${colors.AppBgColor};
  max-width: 100%;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  ${MQ.MediaSm} {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  ${MQ.MediaMd} {
    min-height: 627px;
    width: 840px;
  }
`;
